import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import classes from "./RuleWizard.module.css";

const WizardStepTriggerType = ({ onNext }) => {
    const { state, dispatch } = useRule();

    const handleSelectType = (type) => {
        if (state.triggerType === type) return;

        dispatch({ type: "SET_TRIGGER_TYPE", payload: type });

        if (type === "GATEWAY") {
            dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
            dispatch({ type: "SET_TRIGGER_TIME", payload: null });
            dispatch({ type: "SET_TRIGGER_TIMEZONE", payload: null });
            dispatch({ type: "SET_SELECTED_PIN", payload: null });
            dispatch({ type: "SET_PIN_NAME", payload: "" });
            dispatch({ type: "SET_PIN_NUMBER", payload: 0 });
        } else {
            dispatch({ type: "SET_GATEWAY_TRIGGER", payload: null });
            dispatch({ type: "SET_GATEWAY_EVENT_FAMILY", payload: "" });
            dispatch({ type: "SET_GATEWAY_EVENT_SUBTYPE", payload: "" });
        }

        if (type === "SWITCH") {
            dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
            dispatch({ type: "SET_TRIGGER_TIME", payload: null });
            dispatch({ type: "SET_TRIGGER_TIMEZONE", payload: null });
        }

        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [] });
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>What triggers this rule?</h2>
                <p className={classes.contentSubtitle}>Choose whether this rule is triggered by a gateway event, an output or input changing state, or a time of day</p>
            </div>

            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
                {/* <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.triggerType === "GATEWAY" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.triggerType === "GATEWAY" ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleSelectType("GATEWAY")}
                >
                    <Checkbox checked={state.triggerType === "GATEWAY"} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Gateway event</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Trigger the rule when a padlock event occurs, e.g. correct pin entered, padlock opened/closed, or an invalid pin was attempted</p>
                    </div>
                </div> */}

                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.triggerType === "SWITCH" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.triggerType === "SWITCH" ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleSelectType("SWITCH")}
                >
                    <Checkbox checked={state.triggerType === "SWITCH"} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>An output or input changes state</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Trigger the rule when an output or input changes to a chosen state</p>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${state.triggerType === "TIME" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: state.triggerType === "TIME" ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => handleSelectType("TIME")}
                >
                    <Checkbox checked={state.triggerType === "TIME"} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Time of day</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Trigger the rule at a specific time and day of the week, checking the chosen output or input state</p>
                    </div>
                </div>
            </div>

            <div className={classes.navRow}>
                <div />
                <Button
                    label="Next"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    severity="success"
                    disabled={!state.triggerType}
                    onClick={onNext}
                />
            </div>
        </>
    );
};

export default WizardStepTriggerType;
